import React, { useEffect, useState, useCallback } from 'react';
import { notification, Modal, Input } from 'antd';
import { getUsers, impersonateUser } from '../../../Apis/God';
import AddForm from './addForm';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AddUser } from '../../../Redux/Actions/User';
import PageTitle from '../../../Utils/PageTitle';
import { TitleRow, ContainerRow } from '../styledComponents';
import CustomTypography from '../../CustomComponents/CustomTypography';
import TanStackUserTable from './TanStackUserTable';

const UserManagement = () => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const dispatch = useDispatch();
  const history = useHistory();

  const [users, setUsers] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await getUsers();
      const list = Array.isArray(res?.data?.result) ? res.data.result : [];
      setUsers(list);
    } catch (error) {
      console.error('Failed to fetch users:', error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const onViewLogs = useCallback(
    user => history.push(`/dashboard/user-management/${user.id}/logs`),
    [history]
  );

  const onImpersonate = useCallback(
    async user => {
      try {
        const response = await impersonateUser(user.id);
        if (response?.data?.success === true) {
          const data = response.data.result[0];
          const token = data.token;
          sessionStorage.clear();
          localStorage.clear();
          dispatch(AddUser(data));
          localStorage.setItem('user', JSON.stringify(data));
          localStorage.setItem('loggedIn', true);
          if (token) localStorage.setItem('accessToken', token);
          notification.success({
            message: 'Impersonation Successful',
            description: `You are now logged in as ${data.firstName || ''} ${data.lastName || ''}`.trim()
          });
          if (data.userType === 'biller') {
            history.push('/dashboard/biller');
          } else if (data.userType === 'reviewer') {
            history.push('/dashboard/jobs-list/jobs-to-review/ready');
          } else if (data.userType === 'scribe') {
            history.push('/dashboard/jobs-list/my-jobs/in-progress');
          } else {
            history.push('/dashboard');
          }
        } else {
          notification.error({
            message: 'Failed',
            description: response?.data?.message || 'Unable to impersonate user'
          });
        }
      } catch (error) {
        console.error('Failed to impersonate user:', error);
      }
    },
    [dispatch, history]
  );

  const onEditPassword = useCallback(user => {
    setSelectedItem(user);
    setDrawerVisible(true);
  }, []);

  return (
    <>
      <PageTitle title='User Management' />
      <ContainerRow gutter={[0, 40]}>
        <TitleRow justify='space-between'>
          <CustomTypography color={theme['@text-color']}>
            User Management
          </CustomTypography>
          <Input.Search
            placeholder='Search users...'
            allowClear
            style={{ width: 280 }}
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            onSearch={value => setSearchValue(value)}
          />
        </TitleRow>

        <TanStackUserTable
          users={users}
          tableLoading={loading}
          searchValue={searchValue}
          onEditPassword={onEditPassword}
          onViewLogs={onViewLogs}
          onImpersonate={onImpersonate}
        />

        <Modal
          title='Update Password'
          open={drawerVisible}
          centered
          footer={null}
          onCancel={() => setDrawerVisible(false)}
          width={400}
        >
          {selectedItem && (
            <AddForm
              selectedUser={selectedItem}
              onSuccess={() => setDrawerVisible(false)}
            />
          )}
        </Modal>
      </ContainerRow>
    </>
  );
};

export default UserManagement;
